var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2479_3951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30709 6.25879C2.05028 7.89398 1.10259 9.77866 0.550781 11.8261H8.87441L3.30709 6.25879Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4485 11.826C30.8967 9.77866 29.9489 7.89398 28.6922 6.25879L23.125 11.826H31.4485Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.1738C1.10266 22.2212 2.05034 24.1059 3.30709 25.741L8.87422 20.1738H0.550781Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7411 3.30716C24.1059 2.05034 22.2213 1.10266 20.1738 0.550781V8.87434L25.7411 3.30716Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25781 28.6921C7.893 29.9489 9.77769 30.8966 11.8251 31.4485V23.125L6.25781 28.6921Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.825 0.550781C9.77762 1.10266 7.89294 2.05034 6.25781 3.30709L11.825 8.87428V0.550781Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 31.4485C22.2212 30.8966 24.1059 29.9489 25.741 28.6922L20.1738 23.125V31.4485Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.125 20.1738L28.6922 25.7411C29.9489 24.106 30.8967 22.2212 31.4485 20.1738H23.125Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9131H18.0871H18.087V0.135438C17.4038 0.0465 16.7073 0 16 0C15.2926 0 14.5962 0.0465 13.9131 0.135438V13.9129V13.913H0.135438C0.0465 14.5962 0 15.2927 0 16C0 16.7074 0.0465 17.4038 0.135438 18.0869H13.9129H13.913V31.8646C14.5962 31.9535 15.2926 32 16 32C16.7073 32 17.4038 31.9536 18.0869 31.8646V18.0871V18.087H31.8646C31.9535 17.4038 32 16.7074 32 16C32 15.2927 31.9535 14.5962 31.8646 13.9131Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 20.1739L27.3136 27.3136C27.642 26.9854 27.9552 26.6422 28.2541 26.2865L22.1415 20.1738H20.1738V20.1739Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8254 20.1738H11.8252L4.68555 27.3135C5.0138 27.6419 5.35698 27.9551 5.71273 28.254L11.8254 22.1413V20.1738Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8263 11.8265V11.8263L4.68659 4.68652C4.35822 5.01477 4.04497 5.35796 3.74609 5.71371L9.85878 11.8264H11.8263V11.8265Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 11.8264L27.3136 4.68653C26.9854 4.35816 26.6422 4.04491 26.2865 3.74609L20.1738 9.85878V11.8264Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2479_3951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.6b4377f5e552529a0572fabe5d05afb6.svg";
export { ForwardRef as ReactComponent };